import { useEffect, useState } from 'react';

/**
 * Devuelve el ancho actual de la ventana y lo mantiene actualizado.
 *
 * Lo usan los carruseles para recalcular sus medidas cuando cambia el tamaño de
 * la pantalla o se gira el dispositivo.
 *
 * El manejador se define dentro del efecto: antes vivía fuera y el efecto se
 * suscribía a una referencia que se recreaba en cada render, de modo que el
 * removeEventListener del cleanup intentaba quitar una función distinta a la
 * registrada y los listeners se acumulaban.
 */
const useScreenSize = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { width };
};

export default useScreenSize;
